/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadPackageResponseSchema
 */
export interface UploadPackageResponseSchema {
    /**
     * 
     * @type {number}
     * @memberof UploadPackageResponseSchema
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPackageResponseSchema
     */
    shouldUpload: boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadPackageResponseSchema
     */
    uploadUrl: string;
}

/**
 * Check if a given object implements the UploadPackageResponseSchema interface.
 */
export function instanceOfUploadPackageResponseSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "shouldUpload" in value;
    isInstance = isInstance && "uploadUrl" in value;

    return isInstance;
}

export function UploadPackageResponseSchemaFromJSON(json: any): UploadPackageResponseSchema {
    return UploadPackageResponseSchemaFromJSONTyped(json, false);
}

export function UploadPackageResponseSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadPackageResponseSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shouldUpload': json['should_upload'],
        'uploadUrl': json['upload_url'],
    };
}

export function UploadPackageResponseSchemaToJSON(value?: UploadPackageResponseSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'should_upload': value.shouldUpload,
        'upload_url': value.uploadUrl,
    };
}

